import React, { useState } from 'react';
import EnquiryModal from './EnquiryModal';
import logo from '../img/logo-emperica.png'
import logoblack from '../img/logo-emperica-black.jpg'


const Navbar = ({ scrollToSection, refs }) => {
     const [showModal, setShowModal] = useState(false);
     const [showContactModal, setContactShowModal] = useState(false);
  return (
    <div className="container-fluid sticky-top px-0">
      <nav className="navbar navbar-expand-lg navbar-dark bg-light py-3 px-4">
        <a href="/" className="navbar-brand p-0">
          {/* <h1 className="text-secondary display-6">
            <i className="fas fa-city text-primary me-3"></i>Constra
          </h1> */}
          <img src={logoblack} alt="Logo"   style={{borderRadius:'5px'}} />
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse"
        >
          <span className="fa fa-bars"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarCollapse">
          <div className="navbar-nav ms-auto pt-2 pt-lg-0">


            <a href="#" className="nav-item nav-link active"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            >
              Home
            </a>



            



            <a href="#" className="nav-item nav-link"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection(refs.priceRef);
              }}
            >
              Price
            </a>
            <a href="#" className="nav-item nav-link"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection(refs.siteandfloorplanRef);
              }}
            >
              Site & Floor Plan
            </a>


              <a href="#" className="nav-item nav-link"
                onClick={(e) => {
                e.preventDefault();
                scrollToSection(refs.amenitiesRef);
              }}
              >
              Amenities
            </a>


            <a href="#" className="nav-item nav-link"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection(refs.galleryRef);
              }}
            >
              Gallery
            </a>


             <a href="#" className="nav-item nav-link"
              onClick={(e) => {
                e.preventDefault();
                // document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                scrollToSection(refs.locationRef);
              }}
             >
              Location
            </a>


           

            {/* <div className="nav-item dropdown">
              <a
                href="#"
                className="nav-link dropdown-toggle text-dark"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Pages
              </a>
              <div className="dropdown-menu m-lg-0">
                <a href="/feature" className="dropdown-item">
                  Our Features
                </a>
                <a href="/blog" className="dropdown-item">
                  Our Blog
                </a>
                <a href="/team" className="dropdown-item">
                  Our Team
                </a>
                <a href="/testimonial" className="dropdown-item">
                  Testimonial
                </a>
                <a href="/404" className="dropdown-item">
                  404 Page
                </a>
              </div>
            </div> */}

            <a href="#" className="nav-item nav-link"
             onClick={() => setContactShowModal(true)}
            >
              Contact
            </a>
          </div>

          <div className="d-flex align-items-center flex-nowrap pt-3 pt-lg-0 ms-lg-2">
         
          <a
  href="#"
  className="btn btn-secondary py-2 px-4 ms-3 flex-wrap flex-sm-shrink-0"
  onClick={() => setShowModal(true)}
>
  Get a Quote
</a>
<EnquiryModal show={showModal} onClose={() => setShowModal(false)} formtitle={" Send Quote"} />
<EnquiryModal show={showContactModal} onClose={() => setContactShowModal(false)} formtitle={" Contact Us"} />

          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
